import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=720dee9d&scoped=true"
import script from "./AttachmentList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttachmentList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AttachmentList.vue?vue&type=style&index=0&id=720dee9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720dee9d",
  null
  
)

export default component.exports